import { Link, useLocation, useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { LogOut, Settings, MessageSquare } from "lucide-react";
import { toast } from "sonner";
import { supabase } from "@/integrations/supabase/client";
import PersonaDropdown from "@/components/layout/PersonaDropdown";
import { MessageNotifications } from "@/components/messaging/MessageNotifications";
import { usePersonaContext } from "@/contexts/PersonaContext";

export const GSDocumentToolNavbar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { currentPersona } = usePersonaContext();
  const isGSClientPortal = location.pathname === "/gs-client-portal";
  const isGSClientUser = currentPersona?.name === "GS Client User";
  
  const handleLogout = async () => {
    try {
      const { error } = await supabase.auth.signOut();
      
      if (error) {
        throw error;
      }
      
      toast.success("You have been logged out");
      navigate("/login");
    } catch (error: any) {
      console.error("Logout error:", error);
      toast.error(error.message || "Logout failed");
    }
  };

  return (
    <header style={{ backgroundColor: "#002a19" }} className="border-b border-border/40">
      <div className="container flex h-16 items-center justify-between">
        <Link to="/" className="flex items-center gap-2">
          <img 
            src="/lovable-uploads/3ddc5fa1-0682-40d1-b271-3e72e712719d.png" 
            alt="GS Document Tool Logo" 
            className="h-8 w-auto" 
          />
        </Link>
        
        <div className="flex items-center gap-4">
          <Link to="/messages">
            <Button 
              variant="ghost" 
              size="sm" 
              className={`text-white hover:text-white hover:bg-white/10 ${
                location.pathname === "/messages" ? "font-medium bg-white/20" : ""
              }`}
            >
              <MessageSquare className="h-4 w-4 mr-2" />
              Messages
            </Button>
          </Link>
          <MessageNotifications 
            onMessageClick={() => navigate("/messages")}
            className="text-white hover:bg-white/10"
          />
          <Link to="/settings">
            <Button 
              variant="ghost" 
              size="sm" 
              className={`text-white hover:text-white hover:bg-white/10 ${
                location.pathname === "/settings" ? "font-medium bg-white/20" : ""
              }`}
            >
              <Settings className="h-4 w-4 mr-2" />
              Settings
            </Button>
          </Link>
          <PersonaDropdown className="text-white border-white/20 hover:bg-white/10" />
          <Button 
            variant="ghost" 
            size="sm" 
            onClick={handleLogout}
            className="text-white hover:text-white hover:bg-white/10"
          >
            <LogOut className="h-5 w-5 mr-2" />
            Logout
          </Button>
        </div>
      </div>
    </header>
  );
};